import * as React from "react"
import styled from "styled-components"
import H3 from "../../atoms/typography/H3"
import { Col } from "react-grid-system"
import { HorizontalSpacer } from "../../atoms/spacers"
import BodyText from "../../atoms/typography/BodyText"
import { LocalOrientation } from "../../../types"
import { MediaQuery } from "../../../utils/design-helpers"
import { DeepPartial } from "edge-proto/dist/edge/v1/metrics"
import { orientationToString } from "../../../utils/formatters"

interface LocalOrientationFieldProps {
  title: string
  orientation?: DeepPartial<LocalOrientation>
}

const LocalOrientationFieldContainer = styled.div`
  display: flex;
  min-width: 285px;
  padding: 16px 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;

  border-top: 3px solid ${(props) => props.theme.colors.greyLight};
  border-bottom: 3px solid ${(props) => props.theme.colors.greyLight};
  background: ${(props) => props.theme.colors.white};

  ${MediaQuery.SM} {
    min-width: 0;
    padding: 16px 0px;
    margin: 0px -15px;
  }
`

const LocalOrientationValuesRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

const LocalOrientationField: React.FunctionComponent<LocalOrientationFieldProps> = ({ title, orientation }) => {
  return (
    <LocalOrientationFieldContainer>
      <H3 style={{ alignSelf: "center" }} textAlign="center">
        {title}
      </H3>
      <HorizontalSpacer spacing={1} />
      <LocalOrientationValuesRow>
        <Col>
          <BodyText textAlign="center">Alpha</BodyText>
          <HorizontalSpacer spacing={1} />
          <BodyText textAlign="center" disabled={orientation?.alpha == undefined}>
            {orientationToString(orientation?.alpha)}
          </BodyText>
        </Col>
        <Col>
          <BodyText textAlign="center">Beta</BodyText>
          <HorizontalSpacer spacing={1} />
          <BodyText textAlign="center" disabled={orientation?.beta == undefined}>
            {orientationToString(orientation?.beta)}
          </BodyText>
        </Col>
        {orientation?.gamma !== undefined && (
          <Col>
            <BodyText textAlign="center">Gamma</BodyText>
            <HorizontalSpacer spacing={1} />
            <BodyText textAlign="center">{orientationToString(orientation.gamma)}</BodyText>
          </Col>
        )}
      </LocalOrientationValuesRow>
    </LocalOrientationFieldContainer>
  )
}

export default LocalOrientationField
